import React, { memo } from 'react'
import { Switch } from 'transfix-ui/components/Switch'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { DriverSettingsType } from 'apps/fleet-planner/types'

const useStyles = makeStyles({
  toggle: {
    marginLeft: '11px',
  },
})

export interface IDriverToggleProps {
  driverSettings: DriverSettingsType
  onChangeHandler: (settings: DriverSettingsType) => void
  isDeactivated?: boolean
}

export const DriverUpdatesToggle = memo<IDriverToggleProps>(
  ({ driverSettings, isDeactivated, onChangeHandler }) => {
    const { smsStatusUpdatesEnabled } = driverSettings || {}
    const { toggle } = useStyles()
    const toggleDriverUpdates = () => {
      onChangeHandler({
        smsStatusUpdatesEnabled: !smsStatusUpdatesEnabled,
      })
    }

    return (
      <Switch
        className={toggle}
        checked={smsStatusUpdatesEnabled}
        dataTest='driver-updates-toggle'
        label='Enable driver status updates for all loads'
        onChange={toggleDriverUpdates}
        disabled={isDeactivated}
      />
    )
  }
)
